module.exports = __webpack_public_path__ + "static/media/bakulla.c169589d.png";